module.exports = __webpack_public_path__ + "media/images/logo/logo-bfdb61e32950f509bf3d566af59d9dcb.svg";